import { useEffect, useState } from 'react';
import { withNamespaces } from 'react-i18next';
import { Button } from 'reactstrap';

import DateUtils from 'src/services/utils/DateUtils';
import { INTERNATIONAL_DATE_FORMAT } from 'src/common/constants';
import { CountryFlag, sectionComponents } from './sections';

const dateUtils = new DateUtils();

const ReportDetail = ({
    report,
    t,
}) => {
    const [activeSection, setActiveSection] = useState(report.sections[0]?.key);
    const Section = sectionComponents[activeSection];

    useEffect(() => {
        setActiveSection(report.sections[0]?.key);
    }, [report.id, report.sections]);

    const summary = [
        {
            icon: 'ri-checkbox-circle-line',
            label: 'Legal status',
            value: t(report.identity.legalStatus),
        },
        {
            icon: 'ri-map-pin-line',
            label: 'Country',
            value: (
                <CountryFlag
                    country={report.identity.country}
                    countryName={report.identity.countryName}
                />
            ),
        },
        {
            icon: 'ri-hashtag',
            label: report.identity.register.register === 'UID' ? 'UID' : 'Register number',
            value: report.identity.register.number,
        },
    ];

    return (
        <div className="company-report-detail">
            <div className="d-flex flex-wrap justify-content-between align-items-start gap-3 mb-4">
                <div>
                    <h4 className="mb-1">{report.companyName}</h4>
                    <p className="text-muted mb-0">
                        {`${report.provider} · ${t('Last updated')} ${dateUtils.convertDateToDate(report.fetchedOn, INTERNATIONAL_DATE_FORMAT)} · ${t('Dataset')}: ${report.dataset}`}
                    </p>
                </div>

                <Button color="secondary" outline type="button">
                    <i className="ri-download-2-line align-middle me-1" />
                    {t('Download Report')}
                </Button>
            </div>

            <div className="company-report-summary mb-4">
                {summary.map((item) => (
                    <div className="company-report-summary-card" key={item.label}>
                        <i className={`${item.icon} text-primary`} />
                        <div>
                            <span className="text-muted d-block font-size-12">{t(item.label)}</span>
                            <span className="fw-medium">{item.value}</span>
                        </div>
                    </div>
                ))}
            </div>

            <div className="company-report-body">
                <div className="company-report-sections">
                    {report.sections.map((section) => (
                        <button
                            className={`company-report-section ${activeSection === section.key ? 'is-active' : ''}`}
                            key={section.key}
                            onClick={() => setActiveSection(section.key)}
                            type="button"
                        >
                            {t(section.title)}
                        </button>
                    ))}
                </div>

                <div className="company-report-content">
                    {Section ? <Section identity={report.identity} /> : null}
                </div>
            </div>
        </div>
    );
};

export default withNamespaces()(ReportDetail);
